import { render } from "./TextPart.vue?vue&type=template&id=c81cd700&scoped=true"
import script from "./TextPart.vue?vue&type=script&lang=js"
export * from "./TextPart.vue?vue&type=script&lang=js"

import "./TextPart.vue?vue&type=style&index=0&id=c81cd700&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81cd700"]])

export default __exports__